import * as Types from './types'

export const FETCH_EXCLUDED_LIST = 'FETCH_EXCLUDED_LIST'
export const ADD_EXCLUDED_LIST = 'ADD_EXCLUDED_LIST'
export const UPDATE_BLACKLIST = 'UPDATE_BLACKLIST'
export const UPDATE_BLACKLIST_SEARCH_STRING = 'UPDATE_BLACKLIST_SEARCH_STRING'

export const SERVER_RESOURCE = '/blacklist'

export const emptyModalState: Types.ModalData = {
  type: 'image',
  url: '',
}

export const modalStateValid = (state: Types.ModalData): boolean =>  state.type !== '' && state.url !== ''



// WEBPACK FOOTER //
// ./src/pages/blacklists/constants.ts